module.exports = __webpack_public_path__ + "media/assets/Edit-8a38e70655910e522a93c5dc1ac6ecce.svg";